import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";

import ValidatedPws from "../../../components/ValidatedInput/ValidatedPws/ValidatedPws";
import ButtonFotter from "../../../components/Button/ButtonFotter/ButtonFotter";
import OTPInput from "../../../components/TextInput/OtpInput/OtpInput";
import RecoverPwsOtpImg from "../../../assets/recoverPwsImage2.svg";
import Typography from "../../../components/Typography/Typography";
import Button from "../../../components/Button/Button";
import Loader from "../../../components/Loader/Loader";
import Modal from "../../../components/Modal/Modal";
import styles from "./RecoverPwsOtp.module.scss";
import codes from "../../../utils/codes";

import { ReactComponent as ArrowLeft } from "../../../assets/arrowLeft.svg";
import { StateContext } from "../../../contexts/state.context";
import { changePasswordUser } from "../../../utils/services";

const RecoverPwsOtp = () => {
	const navigate = useNavigate();
	const { formData } = useContext(StateContext);

	const [pws, setPws] = useState();
	const [pwsError, setPwsError] = useState();
	const [pwsStrength, setPwsStrength] = useState({
		hasLowerCase: false,
		hasUpperCase: false,
		hasNumber: false,
		hasSpecialChar: false,
		isLongEnough: false,
		isTooLong: false,
	});

	const [rePws, setRePws] = useState();
	const [rePwsError, setRePwsError] = useState();

	const [otp, setOtp] = useState();
	const [otpError, setOtpError] = useState();

	const [error, setError] = useState(false);
	const [errorMjs, setErrorMjs] = useState("Error");

	const [modal, setModal] = useState();
	const [loader, setLoader] = useState();

	const OTP_INVALID_MSG = "El código OTP es inválido o expiró.";
	const PASW_INVALID_MSG = "Ingresa una contraseña que no hayas usado antes.";
	const handleBackClick = () => {
		navigate("/forgot-pws");
	};

	const handlePwsChange = (password) => {
		setError(false);
 		setPwsError(false);
    	setRePwsError(false);

		setPws(password);
		setPwsStrength({
			hasLowerCase: /[a-z]/.test(password),
			hasUpperCase: /[A-Z]/.test(password),
			hasNumber: /\d/.test(password),
			hasSpecialChar: /[!@#$%^&*()_+={}[\]:;"'<>,.?/\\|`~-]/.test(
				password
			),
			isLongEnough: password.length >= 8,
			isTooLong: password.length <= 30,
		});
	};

	const isValidPws = (isValid) => {
		if (isValid) return styles.recoverPwsOtpItemValid;
		else return styles.recoverPwsOtpItemInvalid;
	};

	const validatePws = () => {
		const {
			hasLowerCase,
			hasNumber,
			hasSpecialChar,
			hasUpperCase,
			isLongEnough,
			isTooLong,
		} = pwsStrength;

		if (
			!hasLowerCase ||
			!hasNumber ||
			!hasSpecialChar ||
			!hasUpperCase ||
			!isLongEnough ||
			!isTooLong
		)
			return false;
		return true;
	};

	const handleBtnDisabled = () => {
		if (pws && rePws && otp) return false;
		else return true;
	};

	const handleSubmit = () => {
		if (!otp) {
			setOtpError(true);
			return;
		}

		if (otp.length < 6) {
			setOtpError(true);
			return;
		}

		if (!validatePws()) {
			setPwsError(true);
			return;
		}

		if (!rePws) {
			setRePwsError(true);
			return;
		}

		if (rePws !== pws) {
			setRePwsError(true);
			return;
		}

		const cleanOtp = (otp || "").trim();
		const cleanPassword = (pws || "").trim();

		const rData = {
			userIdentifier: String(formData?.id || "").replace(/\D/g, ""),
			newPassword: cleanPassword,
			otp: cleanOtp,
		};

		if (formData?.requestIdentifier) {
        	rData.requestIdentifier = formData.requestIdentifier;
    	}

		setLoader(true);

		changePasswordUser({ formInfo: rData })
			.then(({ code }) => {
				setLoader(false);

				switch (code) {
					case codes.JVB001.code:
						setError(false);
						setModal(true);
						break;

					case codes.JVB010.code:
						setError(true);
						setErrorMjs(PASW_INVALID_MSG);
						break;

					case codes.JVB020.code:
						setOtpError(true);
						setError(true);
						setErrorMjs(OTP_INVALID_MSG);
						break;

					default:
						setError(true);
						setErrorMjs(
							"Algo inesperado sucedió, intente nuevamente o contacte a soporte."
						);
						break;
				}
			})
			.catch((e) => {
				setLoader(false);

				const apiCode = e?.data?.code;

				if (apiCode === codes.JVB020.code) {
					setOtpError(true);
					setError(true);
					setErrorMjs(OTP_INVALID_MSG);
					return;
				}

				if (apiCode === codes.JVB010.code) {
					setError(true);
					setErrorMjs(PASW_INVALID_MSG);
					return;
				}
				setError(true);
				setErrorMjs(
					"Algo inesperado sucedió, intente nuevamente o contacte a soporte."
				);
				console.log(e);
			});
	};

	return (
		<div className={styles.recoverPwsOtpContainer}>
			<div className={styles.recoverPwsOtpTitleContainer}>
				<ArrowLeft
					className={styles.recoverPwsOtpTitleArrow}
					onClick={handleBackClick}
				></ArrowLeft>

				<div className={styles.recoverPwsOtpTitleTxt}>
					<Typography variant="h5">
						Restablece tu contraseña
					</Typography>
				</div>
			</div>

			<div className={styles.recoverPwsOtpCard}>
				<img
					src={RecoverPwsOtpImg}
					alt="recover-pws-img"
					className={styles.recoverPwsOtpCardImg}
				></img>

				<div className={styles.recoverPwsOtpCardContent}>
					<Typography
						variant="h4"
						className={styles.recoverPwsOtpCardTitle}
					>
						Restablece tu contraseña
					</Typography>

					<Typography className={styles.recoverPwsOtpCardTxt}>
						Ingresa el código alfanumérico de seis caracteres que te enviamos y crea
						tu nueva contraseña.
					</Typography>

					<div className={styles.recoverPwsOtpCodeContainer}>
						<OTPInput
							error={otpError}
							onChange={(otp) => {
								setOtpError(false);
								setError(false);
								setOtp(otp);
							}}
							type="text"
						></OTPInput>
						<Typography
							className={styles.recoverPwsOtpPwsOTPErrorMessage}
							color={otpError ? "primary" : "transparent"}
						>
							Código OTP inválido.
						</Typography>
					</div>

					<Typography
						className={styles.recoverPwsOtpCardResend}
						variant="p2"
					>
						Recuerda revisar la carpeta de{" "}
						<span style={{ fontWeight: "500" }}>Spam</span> o{" "}
						<span style={{ fontWeight: "500" }}>Promociones</span>.
					</Typography>

					<ValidatedPws
						className={styles.recoverPwsOtpPwsInput}
						label="Contraseña nueva"
						placeholder="Escribe aquí tu contraseña"
						onChange={handlePwsChange}
						errorMessage="Contraseña inválida"
						error={pwsError}
						setError={setPwsError}
					></ValidatedPws>

					<div className={styles.recoverPwsOtpPwsValidations}>
						<ul className={styles.recoverPwsOtpList}>
							<li
								className={isValidPws(pwsStrength.hasLowerCase)}
							>
								Por lo menos una letra minúscula.
							</li>
							<li
								className={isValidPws(pwsStrength.hasUpperCase)}
							>
								Por lo menos una letra mayúscula.
							</li>
							<li className={isValidPws(pwsStrength.hasNumber)}>
								Por lo menos un número.
							</li>
							<li
								className={isValidPws(
									pwsStrength.hasSpecialChar
								)}
							>
								Por lo menos un caracter especial.
							</li>
							<li
								className={isValidPws(pwsStrength.isLongEnough)}
							>
								Mínimo 8 caracteres.
							</li>
						</ul>
					</div>

					<ValidatedPws
						className={styles.recoverPwsOtpPwsInput}
						label="Escríbe de nuevo tu contraseña"
						placeholder="Escribe aquí tu contraseña"
						errorMessage="Las contraseñas no coinciden"
						onChange={(value) => {
        					setError(false);
							setRePwsError(false);
							setRePws(value);
    					}}
						error={rePwsError}
						setError={setRePwsError}
					></ValidatedPws>

					<Typography color={error ? "red" : "transparent"}>
						{errorMjs}
					</Typography>
				</div>
			</div>

			<ButtonFotter onClick={handleSubmit} disabled={handleBtnDisabled()}>
				Cambiar contraseña
			</ButtonFotter>

			{modal && (
				<Modal title="¡Contraseña cambiada!" isSuccess>
					<>
						<Typography className={styles.recoverPwsOtpModalTxt}>
							Tu contraseña ha sido actualizada. Ya puedes{" "}
							<span style={{ fontWeight: "500" }}>
								iniciar sesión
							</span>{" "}
							de forma segura.
						</Typography>
						<Button
							className={styles.recoverPwsOtpModalBtn}
							onClick={() => navigate("/login")}
						>
							Iniciar sesión
						</Button>
					</>
				</Modal>
			)}

			{loader && <Loader />}
		</div>
	);
};

export default RecoverPwsOtp;
